var base = require('settings/teams/update-team-name');

Vue.component('spark-update-team-name', {
    mixins: [base],

    data() {
        return {
            form: new SparkForm({
                name: '',
            })
        };
    },

    mounted() {
        this.form.name = this.team.name;
    },
});
